import { Contact } from './types';
import { fetchContactList } from './api';

/**
 * Fetch contacts from MySQL database
 * Returns array of contacts and the next ID to use
 */
export async function loadContactsData(): Promise<{ contacts: Contact[], nextId: number }> {
  const data = await fetchContactList();

  const contacts: Contact[] = Object.values(data.contacts).map((contact: any) => ({
    id: contact.id,
    name: contact.name,
    phone: contact.phone || '',
    category: contact.category,
    notes: contact.notes || ''
  }));

  return {
    contacts,
    nextId: data.contactNextID
  };
}

// Fallback empty array for backwards compatibility
// Horse owners are automatically derived from horse data in PhoneList component
const contacts: Contact[] = [];
export default contacts;
